/**
 * Warehouse's standard search can treat a category name as a loose keyword.
 * When a customer enters an exact product type, submit it as that category so
 * the full results page stays consistent with predictive search.
 */
(function () {
  function findExactProductType(form) {
    var input = form.querySelector('[name="q"]');
    var productTypeSelect = form.querySelector('#search-product-type');

    if (!input || !productTypeSelect || productTypeSelect.value !== '') {
      return null;
    }

    var term = input.value.trim().toLowerCase().replace(/\s+/g, ' ');

    if (term === '') {
      return null;
    }

    for (var index = 0; index < productTypeSelect.options.length; index += 1) {
      var option = productTypeSelect.options[index];
      var productType = option.value.trim().toLowerCase().replace(/\s+/g, ' ');

      if (
        productType !== '' &&
        (productType === term || (' ' + term + ' ').indexOf(' ' + productType + ' ') !== -1)
      ) {
        return { input: input, option: option, select: productTypeSelect };
      }
    }

    return null;
  }

  function applyExactProductType(form) {
    var match = findExactProductType(form);

    if (match) {
      match.select.value = match.option.value;
      match.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (form && form.matches && form.matches('.search-bar')) {
        applyExactProductType(form);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var searchLink = event.target.closest('.search-bar a[href*="/search?q="]');

      if (!searchLink) {
        return;
      }

      var form = searchLink.closest('.search-bar');
      var match = form ? findExactProductType(form) : null;

      if (match) {
        var query = 'product_type:' + match.option.value + ' AND ' + match.input.value.trim();
        searchLink.href = '/search?type=product&q=' + encodeURIComponent(query);
      }
    },
    true
  );
})();

/* DD_HIGH_VARIANT_PICKER_2026_08_22_START */
(function () {
  'use strict';

  function rootFor(input) {
    return input.closest('[data-section-type="product"]') ||
      input.closest('.shopify-section') ||
      input.closest('.product') ||
      document;
  }

  function updateImage(root, input) {
    var imageUrl = input.getAttribute('data-variant-image');
    if (!imageUrl) return;
    var gallery = root.querySelector('.product-gallery');
    if (!gallery) return;
    var image = gallery.querySelector('.product-gallery__carousel-item.is-selected img') ||
      gallery.querySelector('.product-gallery__carousel-item img') ||
      gallery.querySelector('img');
    if (!image) return;
    var picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('data-srcset');
      });
    }
    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');
    image.setAttribute('src', imageUrl);
    image.setAttribute('data-src', imageUrl);
    image.setAttribute('alt', input.getAttribute('data-variant-image-alt') || input.value);
    var link = image.closest('a');
    if (link) link.setAttribute('href', imageUrl);
  }

  function applyVariant(input, updateHistory) {
    if (!input) return;
    var picker = input.closest('[data-dd-high-variant-picker]');
    var form = input.closest('form[action*="/cart/add"]');
    if (!picker || !form) return;
    var root = rootFor(input);
    var variantId = input.getAttribute('data-variant-id');
    var available = input.getAttribute('data-variant-available') === 'true';
    var master = form.querySelector('select[name="id"]');
    if (master) {
      master.value = variantId;
      Array.prototype.forEach.call(master.options, function (option) {
        option.selected = option.value === variantId;
      });
      master.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var selectedValue = picker.querySelector('.product-form__selected-value');
    if (selectedValue) selectedValue.textContent = input.value;

    var priceList = form.querySelector('.price-list');
    if (priceList) {
      priceList.innerHTML = '<span class="price"><span class="visually-hidden">Sale price</span>' +
        input.getAttribute('data-variant-price') + '</span>';
    }

    var skuWrap = root.querySelector('.product-meta__sku');
    var skuNumber = skuWrap && skuWrap.querySelector('.product-meta__sku-number');
    var sku = input.getAttribute('data-variant-sku') || '';
    if (skuWrap && skuNumber) {
      skuNumber.textContent = sku;
      skuWrap.style.display = sku ? '' : 'none';
    }

    var inventory = form.querySelector('.product-form__inventory');
    if (inventory) {
      inventory.classList.toggle('inventory--high', available);
      inventory.classList.toggle('inventory--low', false);
      inventory.textContent = available ? 'In stock' : 'Sold out';
    }

    var button = form.querySelector('.product-form__add-button');
    if (button) {
      button.disabled = !available;
      button.classList.toggle('button--disabled', !available);
      button.classList.toggle('button--primary', available);
      if (available) {
        button.setAttribute('data-action', 'add-to-cart');
        button.textContent = (window.languages && window.languages.productFormAddToCart) || 'Add to cart';
      } else {
        button.removeAttribute('data-action');
        button.textContent = (window.languages && window.languages.productFormSoldOut) || 'Sold out';
      }
    }

    updateImage(root, input);

    if (updateHistory && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.delete('option_values');
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    root.dispatchEvent(new CustomEvent('dd:high-variant-changed', {
      bubbles: true,
      detail: {
        id: Number(variantId),
        title: input.value,
        available: available,
        price: Number(input.getAttribute('data-variant-price-cents') || 0),
        imageUrl: input.getAttribute('data-variant-image') || ''
      }
    }));
  }

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-dd-high-variant-picker]').forEach(function (picker) {
      applyVariant(picker.querySelector('.dd-high-variant-selector:checked') ||
        picker.querySelector('.dd-high-variant-selector'), false);
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.classList.contains('dd-high-variant-selector')) {
      applyVariant(event.target, true);
    }
  });
  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState !== 'loading') initialize(document);
})();
/* DD_HIGH_VARIANT_PICKER_2026_08_22_END */

/* DD_HIGH_VARIANT_PICKER_V2_2026_09_02_START */
(function () {
  'use strict';

  function rootFor(picker) {
    return picker.closest('[data-section-type="product"]') ||
      picker.closest('.shopify-section') ||
      picker.closest('.product') ||
      document;
  }

  function updateImage(picker) {
    var imageUrl = picker.getAttribute('data-selected-image');
    if (!imageUrl) return;
    var root = rootFor(picker);
    var gallery = root.querySelector('.product-gallery');
    if (!gallery) return;
    var image = gallery.querySelector('.product-gallery__carousel-item.is-selected img') ||
      gallery.querySelector('.product-gallery__carousel-item img') ||
      gallery.querySelector('img');
    if (!image) return;
    var picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('data-srcset');
      });
    }
    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');
    image.setAttribute('src', imageUrl);
    image.setAttribute('data-src', imageUrl);
    image.setAttribute('alt', picker.getAttribute('data-selected-image-alt') || 'Selected product option');
    var link = image.closest('a');
    if (link) link.setAttribute('href', imageUrl);
  }

  function selectedOptionId(group) {
    var select = group.querySelector('[data-dd-high-variant-v2-select]');
    if (select) return select.value;
    var checked = group.querySelector('.dd-high-variant-v2-selector:checked');
    return checked && checked.getAttribute('data-option-value-id');
  }

  function navigateForOption(control) {
    var picker = control.closest('[data-dd-high-variant-v2-picker]');
    if (!picker) return;
    var changedPosition = Number(control.getAttribute('data-option-position') || 0);
    var selectedIds = [];
    picker.querySelectorAll('[data-dd-high-variant-v2-option]').forEach(function (group) {
      var position = Number(group.getAttribute('data-option-position') || 0);
      if (position > changedPosition) return;
      var selectedId = selectedOptionId(group);
      if (selectedId) selectedIds.push(selectedId);
    });
    if (!selectedIds.length) return;
    picker.classList.add('is-loading');
    var url = new URL(picker.getAttribute('data-product-url') || window.location.pathname, window.location.origin);
    url.searchParams.set('option_values', selectedIds.join(','));
    window.location.assign(url.toString());
  }

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-dd-high-variant-v2-picker]').forEach(updateImage);
  }

  document.addEventListener('change', function (event) {
    if (event.target && (
      event.target.classList.contains('dd-high-variant-v2-selector') ||
      event.target.classList.contains('dd-high-variant-v2-select')
    )) {
      navigateForOption(event.target);
    }
  });
  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState !== 'loading') initialize(document);
})();
/* DD_HIGH_VARIANT_PICKER_V2_2026_09_02_END */
